
export default {
  props: {
    blogs: Array,
    title: {
      type: String,
      default: "Read more stories",
    },
  },
  methods: {},
};
